import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Input,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  Tooltip,
  DatePicker,
  InputNumber,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";

const { Text, Title } = Typography;
const { Panel } = Collapse;
const dateFormat = "YYYY-MM-DD";

const EditStandingInstruction = (props) => {
  const { currentCustomerObj, userData, standingObj, refreshList } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [limitDetail, setLimitDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputField, setInputField] = useState([]);
  const [clientDetails, setClientDetails] = useState({});

  const [transferTypeData, setTransferTypeData] = useState([]);
  const [toAccountData, setToAccountData] = useState([]);
  const [toAccountTypeData, setToAccountTypeData] = useState([]);
  const [priorityData, setPriorityData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [fromClientData, setFromClientData] = useState([]);
  const [fromOfficeData, setFromOfficeData] = useState([]);
  const [fromAccountTypeData, setFromAccountTypeData] = useState([]);
  const [fromAccountData, setFromAccountData] = useState([]);
  const [toOfficeData, setToOfficeData] = useState([]);
  const [toClientData, setToClientData] = useState([]);
  const [instructionTypeData, setInstructionTypeData] = useState([]);
  const [recurrenceTypeData, setRecurrenceTypeData] = useState([]);
  const [recurrenceFrequencyData, setRecurrenceFrequencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [liabilityData, setLiabilityData] = useState([]);

  const selectedRecurrenceFrequency = Form.useWatch("recurrenceFrequency", useForm);
  const selectedRecurrenceType = Form.useWatch("recurrenceType", useForm);
  const recurrenceTypeLabel = recurrenceTypeData.find(
    (item) => item.value === selectedRecurrenceType
  )?.label;
  const recurrenceLabel = recurrenceFrequencyData.find(
    (item) => item.value === selectedRecurrenceFrequency
  )?.label;
  const mandateMonthDay =
    recurrenceLabel?.toLowerCase() === "months" || recurrenceLabel?.toLowerCase() === "years";
  const asPerDueSelected = recurrenceTypeLabel?.toLowerCase() === "as per dues recurrence";

  useEffect(() => {}, []);

  function getDetailById() {
    setIsLoading(true);

    const url = `${apiConfig.standingInstructions}/${standingObj.id}?associations=template`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setClientDetails(objDetail.fromClient);

        useForm.setFieldsValue({
          fromAccountType: objDetail.fromAccountType.value,
          name: objDetail.name,
          applicant: objDetail.fromClient.displayName,
          transferType: objDetail.transferType.value,
          priority: objDetail.priority.id,
          status: objDetail.status.id,
          fromAccountId: `${objDetail.fromAccount.productName} - ${objDetail.fromAccount.accountNo}`,
          destination:
            objDetail.fromClient.id === objDetail.toClient.id ? "Own Bank" : "Within Bank",
          toOfficeId: objDetail.toOffice.name,
          toClientId: objDetail.toClient.displayName,
          toAccountType: objDetail.toAccountType.value,
          toAccountId: `${objDetail.toAccount.productName} - ${objDetail.toAccount.accountNo}`,
          instructionType: objDetail.instructionType.id,
          amount: objDetail.amount,
          validFrom: objDetail.validFrom
            ? dayjs(BOM.FormatArrayDate(objDetail.validFrom))
            : objDetail.validFrom,
          validTill: objDetail.validTill
            ? dayjs(BOM.FormatArrayDate(objDetail.validTill))
            : objDetail.validTill,
          recurrenceType: objDetail.recurrenceType.id,
          recurrenceInterval: objDetail.recurrenceInterval,
          recurrenceFrequency: objDetail.recurrenceFrequency
            ? objDetail?.recurrenceFrequency?.id
            : "",
          recurrenceOnMonthDay: objDetail.recurrenceOnMonthDay
            ? dayjs(BOM.FormatArrayDateWithoutYear(objDetail.recurrenceOnMonthDay))
            : objDetail.recurrenceOnMonthDay,
        });

        let tempTransferTypeData = [];
        let tempToAccountData = [];
        let tempToAccountTypeData = [];
        let tempPriorityData = [];
        let tempStatusData = [];
        let tempFromOfficeData = [];
        let tempFromClientData = [];
        let tempFromAccountTypeData = [];
        let tempFromAccountData = [];
        let tempToClientData = [];
        let tempToOfficeData = [];
        let tempInstructionTypeData = [];
        let tempRecurrenceTypeData = [];
        let tempRecurrenceFrequencyData = [];

        objDetail.transferTypeOptions.forEach((element) => {
          tempTransferTypeData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.priorityOptions.forEach((element) => {
          tempPriorityData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.statusOptions.forEach((element) => {
          tempStatusData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.fromOfficeOptions.forEach((element) => {
          tempFromOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail.fromClientOptions.forEach((element) => {
          tempFromClientData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.fromAccountOptions.forEach((element) => {
          tempFromAccountData.push({
            value: element.id,
            label: element.productName,
          });
        });

        objDetail.toOfficeOptions.forEach((element) => {
          tempToOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail.toAccountOptions.forEach((element) => {
          tempToAccountData.push({
            value: element.id,
            label: element.productName,
          });
        });

        objDetail.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.toClientOptions.forEach((element) => {
          tempToClientData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyData.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeData);
        setToAccountTypeData(tempToAccountTypeData);
        setPriorityData(tempPriorityData);
        setStatusData(tempStatusData);
        setFromClientData(tempFromOfficeData);
        setFromOfficeData(tempFromClientData);
        setFromAccountTypeData(tempFromAccountTypeData);
        setFromAccountData(tempFromAccountData);
        setToAccountData(tempToAccountData);
        setToOfficeData(tempToOfficeData);
        setToClientData(tempToClientData);
        setInstructionTypeData(tempInstructionTypeData);
        setRecurrenceTypeData(tempRecurrenceTypeData);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyData);
        setIsLoading(false);
      }
    });
  }

  function removeNullKeys(source) {
    const cleaned = {};
    Object.keys(source || {}).forEach((key) => {
      if (source[key] !== null) {
        cleaned[key] = source[key];
      }
    });
    return cleaned;
  }

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.standingInstructions}/${standingObj.id}?command=update`;

    formValues.validFrom = formValues.validFrom
      ? BOM.DateTime(formValues.validFrom, "only-date")
      : formValues.validFrom;

    formValues.validTill = formValues.validTill
      ? BOM.DateTime(formValues.validTill, "only-date")
      : formValues.validTill;

    formValues.recurrenceOnMonthDay = formValues.recurrenceOnMonthDay
      ? BOM.DateTimeWithoutYear(formValues.recurrenceOnMonthDay, "only-date")
      : formValues.recurrenceOnMonthDay;

    delete formValues.name;
    delete formValues.transferType;
    delete formValues.toOfficeId;
    delete formValues.toClientId;
    delete formValues.toAccountType;
    delete formValues.toAccountId;
    delete formValues.fromAccountType;
    delete formValues.fromAccountId;
    delete formValues.applicant;
    delete formValues.destination;

    const cleanedFormValues = removeNullKeys(formValues);
    // console.log(formValues);
    // return;
    const body = {
      ...cleanedFormValues,
      dateFormat: "dd MMMM yyyy",
      monthDayFormat: "dd MMMM",
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editStandingInstructionMsg);
        // close modal
        setIsModalOpen(false);

        //refresh the list
        refreshList();

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const minDate = dayjs().add(0, "day");
  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return minDate != null && current.isBefore(minDate) && !current.isSame(minDate, "day");
    },
    [minDate]
  );

  return (
    <>
      <Tooltip title={`Edit`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Standing Instruction"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={1000}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="name" label={<Text strong>{labelConfig.name}</Text>}>
                <Input disabled placeholder={BOM.handlePlaceholderMsg(labelConfig.name)} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="applicant" label={<Text strong>{labelConfig.applicant}</Text>}>
                <Input disabled placeholder={BOM.handlePlaceholderMsg(labelConfig.applicant)} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="transferType" label={<Text strong>{labelConfig.type}</Text>}>
                <Select
                  disabled
                  options={transferTypeData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="priority"
                label={<Text strong>{labelConfig.priority}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.priority),
                  },
                ]}
              >
                <Select
                  options={priorityData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.priority, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="status"
                label={<Text strong>{labelConfig.status}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.status),
                  },
                ]}
              >
                <Select
                  options={statusData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.status, "select")}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="fromAccountType"
                label={<Text strong>{labelConfig.fromAccountType}</Text>}
              >
                <Select
                  disabled
                  options={fromAccountTypeData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.fromAccountType, "select")}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="fromAccountId" label={<Text strong>{labelConfig.fromAccount}</Text>}>
                <Select
                  disabled
                  options={fromAccountData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.fromAccount, "select")}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider orientation="left">{labelConfig.beneficiaryInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="destination" label={<Text strong>{labelConfig.destination}</Text>}>
                <Select
                  disabled
                  options={staticConfig.destinationData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.destination, "select")}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="toOfficeId" label={<Text strong>{labelConfig.toBranch}</Text>}>
                <Select
                  disabled
                  options={toOfficeData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.toBranch, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="toClientId" label={<Text strong>{labelConfig.beneficiary}</Text>}>
                <Select
                  disabled
                  options={toClientData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.beneficiary, "select")}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="toAccountType"
                label={<Text strong>{labelConfig.toAccountType}</Text>}
              >
                <Select
                  disabled
                  options={toAccountTypeData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.toAccountType, "select")}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="toAccountId" label={<Text strong>{labelConfig.toAccount}</Text>}>
                <Select
                  disabled
                  options={toAccountData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.toAccount, "select")}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider orientation="left">{labelConfig.instructionInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="instructionType"
                label={<Text strong>{labelConfig.standingInstructionType}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.standingInstructionType),
                  },
                ]}
              >
                <Select
                  options={instructionTypeData}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.standingInstructionType,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="amount" label={<Text strong>{labelConfig.amount}</Text>}>
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="validFrom"
                label={<Text strong>{labelConfig.validityFrom}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.validityFrom),
                  },
                ]}
              >
                <DatePicker
                  disabledDate={disableDaysBeforeToday}
                  // defaultValue={defaultValue}
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.validityFrom, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="validTill"
                label={<Text strong>{labelConfig.to}</Text>}
                // rules={[
                //   {
                //     required: true,
                //     message: BOM.CheckReqFld(labelConfig.to),
                //   },
                // ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.to, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="recurrenceType"
                label={<Text strong>{labelConfig.recurrenceType}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.recurrenceType),
                  },
                ]}
              >
                <Select
                  options={recurrenceTypeData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.recurrenceType, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="recurrenceInterval"
                label={<Text strong>{labelConfig.interval}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.interval),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.interval)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="recurrenceFrequency"
                label={<Text strong>{labelConfig.recurrenceFrequency}</Text>}
                rules={[
                  {
                    required: !asPerDueSelected,
                    message: BOM.CheckReqFld(labelConfig.recurrenceFrequency),
                  },
                ]}
              >
                <Select
                  options={recurrenceFrequencyData}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.recurrenceFrequency, "select")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="recurrenceOnMonthDay"
                label={<Text strong>{labelConfig.onMonthDay}</Text>}
                rules={[
                  {
                    required: mandateMonthDay && !asPerDueSelected,
                    message: BOM.CheckReqFld(labelConfig.onMonthDay),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.onMonthDay, "select")}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default EditStandingInstruction;
